import React from 'react';

import { Translate } from 'react-localize-redux';

const PayoutAlertBanner = () => {
  return (
    <div role="alert" className="flex items-center bg-[#ffbc2c] mb-4 px-4 py-3">
      <p className="text-sm text-primary">
        <Translate id="We_are_unable_to_make_payouts_to_this_bank_account" />
      </p>
    </div>
  );
};

export default PayoutAlertBanner;
